import styled from 'styled-components';

/* Mixins */
import { FlexCenterChildren } from 'styles/Mixins';

/* Utils */
import { mediaQuery } from 'styles/Utils';

export const VideoOverlay = styled.div`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: ${({ theme }) => theme.zIndexModal1};
  display: flex;
`;

export const VideoWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1280px;
  max-height: 720px;
  ${FlexCenterChildren}
  ${mediaQuery.desktop`
    padding: 0 80px;
  `}
  ${mediaQuery.mobile`
    padding: 0;
  `}
`;

export const VideoContentWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
`;

export const WishCloseWrapper = styled.div`
  position: fixed;
  right: 16px;
  top: 16px;
  cursor: pointer;
`;
